import { lazy } from 'react';

export const PlayerCityForm = lazy(() => import('./PlayerCityForm'));
